import angular from 'angular'
import template from './template.html'

export default class NominasNominaColaboradoresListaRemuneradosItemComponent {
  constructor (){
    this.data = {}
    this.editable = false
    this.calculado = false
    this.onDelete = null
    this.onSelect = null
    this.eliminando = false
  }

  eliminar(data) {
    if (data) {
      this.onDelete({$event: {data: data}})
    }

    this.eliminando = false
  }

  seleccionar() {
    this.onSelect({$event: {data: this.data}})
  }
}

angular.module('nominas.nomina')
  .component('nominasNominaColaboradoresListaRemuneradosItem', {
    controller: NominasNominaColaboradoresListaRemuneradosItemComponent,
    template,
    bindings: {
      data: '<',
      editable: '<',
      calculado: '<',
      onDelete: '&',
      onSelect: '&',
    },
  })



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/colaboradores/lista/remunerados/item/component.js